import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const marketingTextRootActionPath = 'core/MarketingText/GET';

export const MARKETING_TEXT_GET_SUCCESS = `${marketingTextRootActionPath}_${SUCCESS_SUFFIX}`;
export const MARKETING_TEXT_GET_FAILURE = `${marketingTextRootActionPath}_${FAILURE_SUFFIX}`;
